import { lazy } from '../../utility/Lazy';

export class Once<T> {
    private running = false;
    private result = lazy<T>();

    async start(func: () => Promise<T>): Promise<T> {
        if (this.running) {
            return await this.result.get();
        }

        this.running = true;
        try {
            const result = await func();
            this.result.setValue(result);
            return result;
        } finally {
            this.running = false;
        }
    }
}

export function once<T>(func: () => Promise<T>) {
    const tmp = new Once<T>();
    return () => { return tmp.start(func); };
}
